module.exports = __webpack_public_path__ + "static/media/icon-ev.b71e7950.svg";